"use strict";

Shopify.theme.jsProduct = {
  init: function init($section) {
    // Add settings from schema to current object
    Shopify.theme.jsProduct = $.extend(this, Shopify.theme.getSectionData($section)); //Ensure product media libraries are present
    var product = $(".product_form").data("product");
    $('.current_price').html('<span class="money">' + Shopify.formatMoney(product.price, $('body').data('money-format')) + '</span>');
	if($('.modal_price').length == 0){
      $('.product_form').addClass('sold_out');
    }
    if($(window).width() < 768) {
      $('.additional-description-image').parent().css({'position': 'relative', 'padding-bottom': '106%'});
    }
      
      

    var $sticky = $('.product-gallery');
    var $stickyrStopper = $('.product__blocks');
    var stickyStopperPosition = $stickyrStopper.offset().top;
    var menuOpen = false;
    if(!$('.product-page').hasClass('abos')) {

      $('.full-description .content-section[data-index="1"]').addClass('active');
      $('.full-description .tab').on('click', function(e){
        var index = $(this).data('index');
        $('.full-description .tab').removeClass('active');
        $('.full-description .content-section').removeClass('active');
        $(this).addClass('active');
        $('.full-description .content-section[data-index="'+ index +'"]').addClass('active');
      });

      // var desc = $('.description .desc');
      // var heightDesc = desc.height();
      // if (heightDesc > 100) {
      //   $('.description .more').css({'display': 'block'});
      //   stickyStopperPosition = $stickyrStopper.offset().top;
      //   var textDesc = document.getElementsByTagName('body')[0].getElementsByClassName('desc')[0];
      //   desc.css({'max-height': 'unset'});
      //   $clamp(textDesc, {clamp: 4});
      //   if(IsSafari()) {
      //     desc.find('> *, li').css({'display': 'contents'});
      //   }
      //   heightDesc = desc.height();
      //   desc.css({'max-height': heightDesc+'px'});
      // }



      // if (heightDesc > 100) {
      //   $('.description .more').css({'display': 'block'});
      //   //$('.description .desc').css({'max-height': '100px'});
      //   var $p = $('.description .desc > *');
      //   var newDesc = '';
      //   $($p.get().reverse()).each(function () {
      //     if ($(this).is('br') || $(this).is('ul')) {
      //       $(this).remove();
      //     }
      //     var text = $(this).text();
      //     while ($('.description .desc').outerHeight() > 97 && text !== '...' && text !== '') {
      //       text = text.slice(0, -6) + '...';
      //       $(this).text(text);
      //       if ($(this).text() == '...') {
      //         $(this).remove();
      //       }
      //     }
      //     if ($('.description .desc').outerHeight() <= 96) {
      //       return false;
      //     }
      //   });
      //   var newDesc = $('.description .desc').html();
      //   $('.description .desc_small').hide();
      //   $('.description .desc').show();
      //
      // }
      //
      $('.description .more').on('click', function () {
        var description_text = $('.description .desc');
        description_text.toggleClass('opened');
        if (description_text.hasClass('opened')) {
          description_text.css({'max-height': heightDesc+'px', '-webkit-line-clamp': 'unset'});
          if(IsSafari()) {
          description_text.find('> *').css({'display':'block'});
            description_text.find('li').css({'display': 'list-item'});
          }

          setTimeout(function () {
            description_text.css({'max-height': '2000px'});
            $('.description .desc p').css({'margin-bottom': '10px'});
            $('.description .more').text(Shopify.translation.description_less);
            stickyStopperPosition = $stickyrStopper.offset().top;
            $sticky.css({
              transition: 'top 0.3s ease 0s'
            });
            menuOpen = true;
            setTimeout(function(){
              galleryPosition();
            }, 300);
          }, 50);
        } else {
          description_text.css({'max-height': heightDesc+'px'});
          if(window.scrollY>0){
            $("html, body").animate({scrollTop: $("div.product__information").offset().top - 250}, "fast");
          }
          setTimeout(function () {
            $('.description .more').text(Shopify.translation.description_more);
            $('.description .desc p').css({'margin-bottom': '0'});
            description_text.css({'-webkit-line-clamp': '4'});
            if(IsSafari()) {
              description_text.find('> *, li').css({'display': 'contents'});
            }
            stickyStopperPosition = $stickyrStopper.offset().top;
          }, 300);
        }
      });


      $('.read-more-collection').on('click', function (e) {
        e.preventDefault();
        if (!$('#fullDescription').is(':visible')) {
          $('#truncated').fadeOut(300, function () {
            $('#fullDescription').slideDown(500);
          });
        } else {
          $('#fullDescription').slideUp(300, function () {
            $('html, body').animate({
              scrollTop: $("div.description").offset().top - 250
            }, 500);
            $('#truncated').fadeIn(500);
          });
        }
      });

    }
    
    window.Shopify.loadFeatures([{
      name: 'model-viewer',
      version: '0.8'
    }, {
      name: 'shopify-xr',
      version: '1.0'
    }, {
      name: 'model-viewer-ui',
      version: '1.0'
    }], Shopify.theme.productMedia.setupMedia);
    var $productGallery = $section.find('.product-gallery__main');
    var $stickyElement = $section.find('.sticky-product-scroll');

    if ($productGallery) {
      Shopify.theme.jsProduct.enableSlideshow($productGallery);

      if (Shopify.theme.jsProduct.enable_zoom) {
        Shopify.theme.jsProduct.enableZoom($productGallery);
      }
      //
      // if (Shopify.theme.jsProduct.enable_product_lightbox) {
      //   Shopify.theme.jsProduct.enableLightbox($productGallery);
      // }

      if (!!$sticky.offset()) { // make sure ".sticky" element exists

        var generalSidebarHeight = $sticky.height();
        var stickyTop = $sticky.offset().top;
        var stickOffset = $sticky.offset().top;
        var stopPoint = stickyStopperPosition - generalSidebarHeight - stickOffset;

        var width = $sticky.width();
        $(window).scroll(function(){ // scroll event
          menuOpen = false;
          galleryPosition();
        });
      }
    }
    function IsSafari() {

      var is_safari = navigator.userAgent.toLowerCase().indexOf('safari/') > -1;
      return is_safari;

    }

    function galleryPosition(){
      if($(window).width() > 1024) {
        if($('.product__information').height() > $sticky.height()) {
          var windowTop = $(window).scrollTop(); // returns number
          var height = $sticky.height();
          $sticky.parent().css({'min-height': height + 'px'});
          stickyStopperPosition = $stickyrStopper.offset().top;
          stopPoint = stickyStopperPosition - height - stickOffset - 40;
          var diff = stopPoint + 40;
          if (stopPoint < windowTop) {
            $sticky.css({
              position: 'absolute',
              top: diff,
              width: width + 'px',
              height: height + 'px',
              transition: 'none'
            });
            setTimeout(function(){
              $sticky.css({
                transition: 'top 0.3s ease 0s'
              });
            }, 100);
          } else if (stickyTop < windowTop + stickOffset && menuOpen) {
            $sticky.css({
              position: 'fixed',
              top: stickOffset,
              width: width + 'px',
              height: height + 'px'
            });
            setTimeout(function(){
              $sticky.css({
                transition: 'top 0.3s ease 0s'
              });
            }, 100);
          } else if (stickyTop < windowTop + stickOffset && !menuOpen) {
            $sticky.css({
              position: 'fixed',
              top: stickOffset,
              width: width + 'px',
              height: height + 'px',
              transition: 'none'
            });
            setTimeout(function(){
              $sticky.css({
                transition: 'top 0.3s ease 0s'
              });
            }, 100);
          } else {
            $sticky.css({
              position: 'fixed',
              top: stickOffset,
              width: width + 'px',
              height: height + 'px',
              transition: 'none'
            });
            setTimeout(function(){
              $sticky.css({
                transition: 'top 0.3s ease 0s'
              });
            }, 100);
          }
        } else {
          $sticky.css({
            position: 'relative',
            top: 0
          });
        }
      }
    }

    if ($stickyElement && isScreenSizeLarge()) {
      Shopify.theme.jsProduct.enableStickyScroll($stickyElement);
    }

    $('.product__information .accordion').on('click', function(){
      if($(this).hasClass('active')){
        stickyStopperPosition = $stickyrStopper.offset().top;
        $sticky.css({
          transition: 'top 0.3s ease 0s'
        });
        menuOpen = true;
        setTimeout(function(){
          galleryPosition();
        }, 300);
      } else {
        $sticky.css({
          transition: 'top 0.3s ease 0s'
        });
        menuOpen = true;
        $("html, body").animate({scrollTop: $("div.description").offset().top - 250}, "fast");
        setTimeout(function () {
          stickyStopperPosition = $stickyrStopper.offset().top;
          galleryPosition();
        }, 300);
      }
    });

    function detectMob() {
      const toMatch = [
        /Android/i,
        /android/i,
        /webOS/i,
        /iPhone/i,
        /iPad/i,
        /iPod/i,
        /BlackBerry/i,
        /Windows Phone/i
      ];

      return toMatch.some(function(toMatchItem) {
        return navigator.userAgent.match(toMatchItem);
      });
    }
    
    var self = this;

    

    if (window.location.search === '?contact_posted=true') {
      $('.notify_form .contact-form').hide();
      $('.notify_form .contact-form').prev('.message').html(Shopify.translation.notify_form_success);
    }

    var $notify_form = $('.notify_form .contact-form');
    $notify_form.each(function () {
      var $nf = $(this);
      $nf.on("submit", function (e) {
        if ($('input[name="challenge"]', $nf).val() !== "true") {
          $.ajax({
            type: $nf.attr('method'),
            url: $nf.attr('action'),
            data: $nf.serialize(),
            success: function success(data) {
              $nf.fadeOut("slow", function () {
                $nf.prev('.message').html(Shopify.translation.notify_form_success);
              });
            },
            error: function error(data) {
              $('input[name="challenge"]', $nf).val('true');
              $nf.submit();
            }
          });
          e.preventDefault();
        }
      });
    });
    
    
      $(".product_form_options", $section).each(function () {
        new Shopify.OptionSelectors($(this).data("select-id"), {
          product: $(this).data("product"),
          onVariantSelected: selectCallback,
          enableHistoryState: $(this).data("enable-state")
        });

    if (Shopify.theme_settings.product_form_style === "swatches") {
      this.enableProductSwatches();
    } else if (Shopify.theme_settings.product_form_style === "dropdown") {
      $('.selector-wrapper select', $section).wrap('<span class="select" data-dropdown-form-style></span>');
      
      
      
      
      
      
      

      if(!detectMob()) {
        var selectWrapper = $(this).find(".selector-wrapper");
        var oldSelect = $(this).find(".selector-wrapper select");

          if ($(this).find(".select-container").hasClass('multi')) {
            $(this).find(".selector-wrapper").each(function(){
              var selectorWrapper = $(this);
              //if(!selectorWrapper.parent().hasClass('abos')){
                //selectorWrapper.find("select").prepend('<option value="default" selected="selected" disabled>' + Shopify.translation.product_size + '</option>').val("default");
              //}

                  selectorWrapper.find("select").prepend('<option value="default" selected="selected" disabled>' + Shopify.translation.product_size + '</option>').val("default");
                  //$(this).find(".custom-select").prepend('<div class="custom-select-option" data-value="default" selected="selected" disabled>' + Shopify.translation.product_size + '</div>');
              selectorWrapper.find(".select").append("<div class='custom-select'></div>");
              selectorWrapper.find('select').children('option').each(function () {
                selectorWrapper.find('.custom-select').append("<div class='custom-select-option' data-value='" + $(this).val() + "'><span>" + $(this).text() + "</span></div>");
              });
            });

              $('.selector-wrapper .custom-select .custom-select-option').on('click', function () {

                $(this).parent().parent().find('select:not(.main)').val($(this).text()).change();
                $(this).parent().find('.custom-select-option').each(function(){
                  $(this).data('selected',false);
                });
                  $(this).data('selected',true);
                  var variant = '';
                  $(this).parent().parent().parent().find('.selector-wrapper .custom-select .custom-select-option').each(function(){
                    if($(this).data('selected') == true) {
                      variant += $(this).text() + ' / ';
                    }
                  });
                  variant = variant.slice(0,-3);
                  if(variant.includes('/')) {
                    var variant_id = $(this).parent().parent().parent().find('.main option:contains("'+variant +'")').val();
                    $(this).parent().parent().parent().find('.main').val(variant_id).change();
                  }
                  $('.selector-wrapper .select').removeClass('opened');
              });
          } else {

            $(this).find(".select-container .selector-wrapper select").prepend('<option value="default" selected="selected" disabled>' + Shopify.translation.product_size + '</option>').val("default");
            selectWrapper.append("<div class='custom-select'></div>");

            $(this).find('select[data-variant-selector]').children('option').each(function () {
              $('.selector-wrapper .custom-select').append("<div class='custom-select-option' data-value='" + $(this).val() + "'><span>" + $(this).text() + "</span></div>");
            });

              $('.selector-wrapper .custom-select .custom-select-option').on('click', function () {
                  $(this).parent().parent().find('select').val($(this).text()).change();
                  $('.selector-wrapper .select').removeClass('opened');
              });
          }
          oldSelect.on('mousedown', function (e) {
            e.preventDefault();
            if($(this).parent().parent().find('.select').hasClass('opened')){
              $(this).parent().parent().find('.custom-select').slideToggle('fast');
              $(this).parent().parent().find('.select').toggleClass('opened');
            } else {
              $('.selector-wrapper .custom-select').slideUp('fast');
              $('.selector-wrapper .select').removeClass('opened');
              $(this).parent().parent().find('.custom-select').slideToggle('fast');
              $(this).parent().parent().find('.select').toggleClass('opened');
            }
          });

           $(document).mouseup(function(e)
           {
             var container = $(".selector-arrow-wrapper .custom-select");

             if(!$(".selector-wrapper select").is(e.target)) {
               if (!container.is(e.target)) {
                 $(".selector-wrapper .select ").removeClass('opened');
                 $('.selector-wrapper .custom-select').slideUp('fast');
               }
             }
           });
      } else {
        if($(window).width() < 1024) {
          $('.select-container').appendTo('.product-form');
        }
          $(".selector-arrow-wrapper select").on('focus', function () {
              $(".selector-wrapper .select ").addClass('opened');
          });
          $(".selector-arrow-wrapper select").on('focusout', function () {
              $(".selector-wrapper .select ").removeClass('opened');
          });
      }
      
      if ($(".select-container").hasClass('multi')) {
        var selectWidth = 0;
        $(".selector-wrapper").each(function () {
          if ($(this).find('.single-option-selector').innerWidth() > selectWidth) {
            selectWidth = $(this).find('.single-option-selector').innerWidth();
          }
        });
        $('.single-option-selector').css({'min-width': selectWidth + 'px'});
        $('.custom-select').css({'min-width': selectWidth + 'px'});
        $('.custom-select').each(function () {
          if ($(this).width() > selectWidth) {
            $(this).css({
              'right': -($(this).width() - selectWidth) / 2 + 'px',
              'left': $('.selector-wrapper label').outerWidth() - ($(this).width() - selectWidth) / 2 + 'px'
            });
          }
        });
      }

      self.findSelectedVariantImage();
   
      
    }
    });

    $(".select-container select").each(function(){
      if($(this).find('option:selected').text() != 'default'){
        $(this).change(function(){
          var text = $(this).find('option:selected').text();
          var $aux = $('<select/>').append($('<option/>').text(text));
          $(this).after($aux);
          $(this).width($aux.width());
          $aux.remove();
        }).change();
      } else {
        $(this).width('115');
      }
    });

    $('select.single-option-selector').change(function(){
      if ($(".select-container").hasClass('multi')) {
        var selectWidth = 0;
        $(".selector-wrapper").each(function () {
          if ($(this).find('.single-option-selector').innerWidth() > selectWidth) {
            selectWidth = $(this).find('.single-option-selector').innerWidth();
          }
        });
        $('.single-option-selector').css({'min-width': selectWidth + 2 + 'px'});
        $('.custom-select').css({'min-width': selectWidth + 2 + 'px'});
        $('.custom-select').each(function () {
          if ($(this).width() > selectWidth + 2) {
            $(this).css({
              'right': -($(this).width() - selectWidth) / 2 + 'px',
              'left': $('.selector-wrapper label').outerWidth() - ($(this).width() - selectWidth) / 2 + 'px'
            });
          }
        });
      }
    });

      
      
      
      
      
      
      

      

    if ($('.masonry--true').length > 0) {
      Shopify.theme.applyMasonry('.thumbnail');
    }

    var collection_blocks = $('.shopify-section.product__block.collection_block .section');
    if(collection_blocks.length>1){
      $(collection_blocks[1]).parent().css({'padding-top':'25px'});
    }
    if($(window).width()<799){
      $(collection_blocks[collection_blocks.length - 1]).parent().css({'padding-bottom':'60px'});
    }



    $('.button--add-to-cart').on('click', function(){
      $('.selector-wrapper').each(function(){
        if($(this).find(".single-option-selector option:selected").val()=='default'){
          $(this).find('.single-option-selector').addClass('warning-select');
        }
      })
    });

    $('.single-option-selector').on('click', function(){
      $(this).removeClass('warning-select');
    });
  },
  enableStickyScroll: function enableStickyScroll($productGallery) {
    var announcementHeight = 0;
    var headerHeight = 0;

    if (typeof Shopify.theme.jsAnnouncementBar !== 'undefined' && Shopify.theme.jsAnnouncementBar.enable_sticky) {
      announcementHeight = $('#announcement-bar').outerHeight();
    }

    if (Shopify.theme_settings.header_layout != 'vertical') {
      if (Shopify.theme.jsHeader.enable_sticky) {
        headerHeight = $('#header').outerHeight();
      }
    }

    $productGallery.stick_in_parent({
      offset_top: announcementHeight + headerHeight + 20
    });
  },
  enableLightbox: function enableLightbox($productGallery) {
    $productGallery.find('.product-gallery__link').fancybox({
      beforeClose: function beforeClose(instance, slide) {
        var $instanceGallery = instance.$trigger.first().parents('.product-gallery__main');
        $instanceGallery.hide();
        setTimeout(function () {
          $instanceGallery.fadeIn(100);
        }, 500);
      },
      afterClose: function afterClose() {
        setTimeout(function () {
          $productGallery.find('.is-selected a').focus();
        }, 500);
      }
    });
  },
  enableZoom: function enableZoom($productGallery) {
    $productGallery.find('img').wrap('<span class="zoom-container"></span>').css('display', 'block').parent().zoom({
      touch: false,
      magnify: 1
    });
  },
   disableSlideshow: function disableSlideshow($section, selector) {
  //   var $slider;
  //
  //   if ($section) {
  //     $slider = $section.find('.flickity-enabled');
  //   } else {
  //     $slider = $(selector);
  //   }
  //
  //   $slider.flickity('destroy');
   },
  enableSlideshow: function enableSlideshow(selector, settings) {
    // Define variables
    var $productGallery = selector;
    var $thumbnailProductGallery = $('.product-gallery__thumbnails'); // Adds 'product-gallery__image' class if not present

    $productGallery.find('.gallery-cell:not(.product-gallery__image)').addClass('product-gallery__image'); // Adds 'product-gallery__thumbnail' class if not present

    $thumbnailProductGallery.find('.gallery-cell:not(.product-gallery__thumbnail)').addClass('product-gallery__thumbnail');
    var $slides = $productGallery.find('.product-gallery__image');
    var $thumbnails = $thumbnailProductGallery.find('.product-gallery__thumbnail');
    var thumbnailsEnabled;
    var thumbnailsSliderEnabled;
    var thumbnailsPosition;
    var arrowsEnabled;
    var slideshowSpeed;
    var slideshowTransition;

    if (settings) {
      // If custom settings available, use them otherwise take settings from product templates
      thumbnailsEnabled = settings.thumbnailsEnabled;
      thumbnailsSliderEnabled = settings.thumbnailsSliderEnabled;
      thumbnailsPosition = settings.thumbnailsPosition;
      arrowsEnabled = settings.arrowsEnabled;
      slideshowSpeed = settings.slideshowSpeed;
      slideshowTransition = settings.slideshowTransition;
    } else {
      thumbnailsEnabled = Shopify.theme.jsProduct.thumbnails_enabled;
      thumbnailsSliderEnabled = Shopify.theme.jsProduct.enable_thumbnail_slider;
      thumbnailsPosition = Shopify.theme.jsProduct.thumbnail_position;
      arrowsEnabled = Shopify.theme.jsProduct.thumbnail_arrows;
      slideshowSpeed = Shopify.theme.jsProduct.slideshow_speed;
      slideshowTransition = Shopify.theme.jsProduct.slideshow_transition;
    }

    // $productGallery.flickity({
    //   wrapAround: true,
    //   adaptiveHeight: true,
    //   dragThreshold: 10,
    //   imagesLoaded: true,
    //   pageDots: false,
    //   prevNextButtons: $productGallery.data('media-count') > 1 || $slides.length > 1 ? true : false,
    //   autoPlay: slideshowSpeed * 1000,
    //   fade: slideshowTransition === 'fade' ? true : false,
    //   watchCSS: this.template === 'image-scroll' ? true : false,
    //   arrowShape: arrowShape
    // });
    var productGallerySlider = new Swiper('.gallery-container.swiper-container', {
      // Optional parameters
      loop: true,
      slidesPerView: 1,
      centeredSlides: true,
      grabCursor: true,
      spaceBetween: 0,
      speed: 500,
      preventInteractionOnTransition: true,
      navigation: {
        nextEl: '.swiper-button.next',
        prevEl: '.swiper-button.previous',
      },
      on: {
        init: function () {
          $slides.each(function (index, slide) {
            //Determine media type
            var mediaType = $(slide).data('media-type') || $(slide).find('[data-media-type]').data('media-type');
            var videoID;
            var videoLooping = $('[data-video-loop]').data('video-loop');

            switch (mediaType) {
              case 'external_video':
                videoID = $(slide).find('[data-plyr-video-id]').data('plyr-video-id');

                if (videoPlayers) {
                  for (var i = 0; i < videoPlayers.length; i++) {
                    if (videoPlayers[i].id == videoID || videoPlayers[i].media.id == videoID) {
                      videoPlayers[i].loop = videoLooping;

                      if (!$(slide).hasClass('is-selected')) {
                        videoPlayers[i].keyboard = {
                          focused: false,
                          global: false
                        };
                      }
                    }
                  }
                }

                break;

              case 'video':
                videoID = $(slide).find('[data-plyr-video-id]').data('plyr-video-id');

                if (videoPlayers) {
                  for (var _i = 0; _i < videoPlayers.length; _i++) {
                    if (videoPlayers[_i].id == videoID || videoPlayers[_i].media.id == videoID) {
                      videoPlayers[_i].loop = videoLooping;

                      if (!$(slide).hasClass('is-selected')) {
                        videoPlayers[_i].keyboard = {
                          focused: true,
                          global: false
                        };
                      }
                    }
                  }
                }

                break;

              // case 'model':
              //   if ($(slide).hasClass('is-selected')) {
              //     //When active slide
              //     if (mediaType == 'model' && isScreenSizeLarge()) {
              //       $(slide).on('mouseenter', function () {
              //         $productGallery.flickity('unbindDrag');
              //       });
              //       $(slide).on('mouseleave', function () {
              //         $productGallery.flickity('bindDrag');
              //       });
              //     }
              //   }

            } // Detect keyboard 'ENTER' key on slides


            $(slide).keypress(function (event) {
              if (event.which == 13) {
                // Bring focus to media inside selected slide
                $(slide).find('model-viewer, .product-gallery__link, .plyr').focus(); // Run video autoplay logic if featured media is a video

                if (mediaType == 'video' || mediaType == 'external_video') {
                  checkForVideos();
                } // Autoplay model if featured media is a model


                if (mediaType == 'model') {
                  // If model container has class is-selected then play the model
                  autoplayModel();
                }
              }
            });
          });


        }
      }
    });


    $('.gallery-container.swiper-container').on('selectChange', function (e) {
      
      var index = $('.gallery-container.swiper-container').attr('data-index-select');
      productGallerySlider.slideTo(index);

//       console.log(index);
//             console.log(e);
    });

    /*productGallerySlider.on('click',function(){
      productGallerySlider.slideNext();
    });*/
    productGallerySlider.on('slideChange',function(e) {
      var slideId = productGallerySlider.realIndex;

      $slides.each(function (index, slide) {
        if(slideId == index) {
          if($(slide).data('media-type') == 'video') {
            var $slide = $(slide);
            var mediaType = $slide.data('media-type') || $slide.find('[data-media-type]').data('media-type');
            var videoID = $slide.find('video').data('plyr-video-id');

            if (mediaType == 'video') {
              videoID = $slide.find('video').data('plyr-video-id');

              if (videoID) {
                autoplayVideo(videoID, $slide);
              }
            }
          }
        }
      });
    });

    productGallerySlider.on('transitionEnd', function () {
      $thumbnails.removeClass('swiper-selected');
      $('.product-gallery__thumbnails').find('[data-index="'+productGallerySlider.realIndex+'"]').addClass('swiper-selected');
      $slides.each(function (index, slide) {
        //Determine media type of current slide
        var mediaType = $(slide).data('media-type') || $(slide).find('[data-media-type]').data('media-type');

        if (!$(slide).hasClass('swiper-slide-active')) {
          //When active slide
          //switch (mediaType) {
            // case 'model':
            //   /* On slide change, if active slide contains 3d model
            //   * If on desktop, on hover, unbind flickity, after hover bind flickity
            //   * On model play event, unbind flickity to ensure model can be interacted with
            //   * On model pause event, bind flickity so that slide can be swiped
            //   * Pause all model slides when hidden
            //   */
            //   if (isScreenSizeLarge()) {
            //     // On mouseenter event, unbind flickity
            //     $(slide).on('mouseenter', function () {
            //       $productGallery.flickity('unbindDrag');
            //     }); // On mouseleave event, bind flickity
            //
            //     $(slide).on('mouseleave', function () {
            //       $productGallery.flickity('bindDrag');
            //     });
            //   } // Listen for model pause/play events
            //
            //
            //   $(slide).find('model-viewer').on('shopify_model_viewer_ui_toggle_play', function () {
            //     $productGallery.flickity('unbindDrag');
            //   });
            //   $(slide).find('model-viewer').on('shopify_model_viewer_ui_toggle_pause', function () {
            //     $productGallery.flickity('bindDrag');
            //   });
            //   break;

        //     default:
        //       $productGallery.flickity('bindDrag');
        //   }
        // } else {
          //When inactive slide
          switch (mediaType) {
            case 'external_video':
              //Youtube video pausing
              $.each(videoPlayers, function (index, player) {
                player.pause();
              });
              break;

            case 'video':
              //HTML5 video pausing
              $.each(videoPlayers, function (index, player) {
                player.pause();
              });
              break;

            case 'model':
              $.each(Shopify.theme.productMedia.models, function (index, model) {
                model.pause();
              });
          }
        }
      }); //Restore 3d model icons

      Shopify.theme.productMedia.showModelIcon($productGallery);
    }); // Checks for videos and plays them if they are the featured media
    // Autoplay logic only happens on desktop, autoplay set to off for mobile

    var $sliderArrows = $('.gallery-container.swiper-container').find('.swiper-button');

    if (($sliderArrows || $thumbnails)) {
      $sliderArrows.on('click', function () {
        productGallerySlider.on('slideChangeTransitionEnd', function (event, index) {
          // Find out media type of featured media slide
          var $selectedSlide = $productGallery.find('.product-gallery__image.swiper-slide-active');
          var mediaType = $selectedSlide.data('media-type') || $selectedSlide.find('[data-media-type]').data('media-type');
          var pId = $productGallery.data('product-id'); // Run video autoplay logic if featured media is a video

          if (mediaType == 'video' || mediaType == 'external_video') {
            checkForVideos();
          } // Autoplay model if featured media is a model


          // if (mediaType == 'model') {
          //   // Sort models to get those in selected slide
          //   var sortedModels = [];
          //   $.each(Shopify.theme.productMedia.models, function (index, model) {
          //     if ($(model.container).closest('.product-gallery__image').data('product-id') == pId) {
          //       sortedModels.push(model);
          //     }
          //   }); // If model container has class is-selected then play the model
          //
          //   $.each(sortedModels, function (index, model) {
          //     var $slide = $(model.container).parents('.product-gallery__image');
          //
          //     if ($slide.hasClass('is-selected')) {
          //       model.play();
          //     }
          //   });
          // }

          productGallerySlider.off('slideChangeTransitionEnd');
        });
        return false;
      });
      $thumbnails.on('click', function (event) {
        var index = $(event.currentTarget).index()+1;
        $('.product-gallery__thumbnail').removeClass('swiper-selected');
        $(event.currentTarget).addClass('swiper-selected');
        productGallerySlider.slideTo(index);
        productGallerySlider.on('slideChangeTransitionEnd', function (event, index) {
          // Find out media type of featured media slide
          var $selectedSlide = $productGallery.find('.product-gallery__image.swiper-slide-active');
          var mediaType = $selectedSlide.data('media-type') || $selectedSlide.find('[data-media-type]').data('media-type');
          var pId = $productGallery.data('product-id'); // Run video autoplay logic if featured media is a video

          if (mediaType == 'video' || mediaType == 'external_video') {
            checkForVideos();
          } // Autoplay model if featured media is a model


          // if (mediaType == 'model') {
          //   // Sort models to get those in selected slide
          //   var sortedModels = [];
          //   $.each(Shopify.theme.productMedia.models, function (index, model) {
          //     if ($(model.container).closest('.product-gallery__image').data('product-id') == pId) {
          //       sortedModels.push(model);
          //     }
          //   }); // If model container has class is-selected then play the model
          //
          //   $.each(sortedModels, function (index, model) {
          //     var $slide = $(model.container).parents('.product-gallery__image');
          //
          //     if ($slide.hasClass('is-selected')) {
          //       model.play();
          //     }
          //   });
          // }

          productGallerySlider.off('slideChangeTransitionEnd');
        });
        return false;
      });
      $thumbnails.keypress(function (event) {
        var index = $(event.currentTarget).index();

        if (event.which == 13) {
          productGallerySlider.slideTo(index);
          var $selectedSlide = $productGallery.find('.product-gallery__image.swiper-slide-active');
          var pId = $productGallery.data('product-id');
          productGallerySlider.on('slideChangeTransitionEnd', function (event, index) {
            $selectedSlide.find('model-viewer, .plyr, a').focus();
            $selectedSlide.find('[data-youtube-video]').attr('tabindex', '0');
            productGallerySlider.off('slideChangeTransitionEnd');
          }); // Find out media type of featured media slide

          var mediaType = $selectedSlide.data('media-type') || $selected.find('[data-media-type]').data('media-type'); // Run video autoplay logic if featured media is a video

          if (mediaType == 'video' || mediaType == 'external_video') {
            checkForVideos();
          } // Autoplay model if featured media is a model


          // if (mediaType == 'model') {
          //   // Sort models to get those in selected slide
          //   var sortedModels = [];
          //   $.each(Shopify.theme.productMedia.models, function (index, model) {
          //     if ($(model.container).closest('.product-gallery__image').data('product-id') == pId) {
          //       sortedModels.push(model);
          //     }
          //   }); // If model container has class is-selected then play the model
          //
          //   $.each(sortedModels, function (index, model) {
          //     var $slide = $(model.container).parents('.product-gallery__image');
          //
          //     if ($slide.hasClass('is-selected')) {
          //       model.play();
          //     }
          //   });
          // }

          return false;
        }
      });
    }

    function checkForVideos() {
      $slides.each(function (index, slide) {
        // Variables
        var $slide = $(slide);
        var mediaType = $slide.data('media-type') || $slide.find('[data-media-type]').data('media-type');
        var videoID = $slide.find('video').data('plyr-video-id');
        var $iframeVideo = $slide.find('iframe');
        var iframeID = $iframeVideo.attr('id');

        if ($slide.hasClass('is-selected')) {
          if (mediaType == 'video') {
            videoID = $slide.find('video').data('plyr-video-id');

            if (videoID) {
              autoplayVideo(videoID, $slide);
            }
          } else if (mediaType == 'external_video' && iframeID) {
            autoplayYoutubeVideo(iframeID, $slide);
          }
        }
      });
    }

    function autoplayVideo(videoID, $slide) {
      // Compare id to player object and only play that video
      $.each(videoPlayers, function (index, player) {
        if (player.id == videoID) {
          player.play(); // On fullscreen toggle, focus back on the slide itself

          player.on('exitfullscreen', function () {
            $slide.closest('.product-gallery').find('.product-gallery__thumbnails').focus();
          });
        }
      });
    }

    function autoplayYoutubeVideo(iframeID, $slide) {
      // compare id to player object and only play that video
      $.each(videoPlayers, function (index, player) {
        if (player.playing) {
          player.pause();
        }

        if (player.media.id == iframeID) {
          player.play(); // On fullscreen toggle, focus back on the slide itself

          player.on('exitfullscreen', function () {
            $slide.closest('.product-gallery').find('.product-gallery__thumbnails').focus();
          });
        }
      });
    }

    // setTimeout(function () {
    //   $productGallery.flickity('resize');
    // }, 500);
    // $(window).on('load', function () {
    //   $productGallery.flickity('resize');
    // });

    if (thumbnailsEnabled == true && thumbnailsSliderEnabled == true && $slides.length > 1) {
      //If desktop determine which slider we build
      if ($(window).width() > 1024) {
        if (thumbnailsPosition == 'right-thumbnails' || thumbnailsPosition == 'left-thumbnails') {
          $thumbnailProductGallery.addClass('vertical-slider-enabled');
          var navCellHeight = $thumbnails.height();
          var navHeight = $thumbnailProductGallery.height();
          productGallerySlider.on('transitionEnd', function () {
              $thumbnailProductGallery.find('.is-nav-selected').removeClass('is-nav-selected');

              var _$selected = $thumbnails.eq(productGallerySlider.realIndex).addClass('is-nav-selected'); // scroll nav


              var scrollY = _$selected.position().top + $thumbnailProductGallery.scrollTop() - (navHeight + navCellHeight) / 2;
              $thumbnailProductGallery.animate({
                scrollTop: scrollY
              });
          });
        } else {
          var thumbnailGallery = new Swiper('.product-gallery__thumbnails.swiper-container', {
            // Optional parameters
            loop: false,
            slidesPerView: 4,
            slidesPerGroup: 4,
            direction: "vertical",
            centeredSlides: false,
            grabCursor: true,
            spaceBetween: 10,
            speed: 500,
            navigation: {
              nextEl: '.swiper-button-gallery.next',
              prevEl: '.swiper-button-gallery.previous',
            }
          });
          // $thumbnailProductGallery.flickity({
          //   cellAlign: 'center',
          //   contain: true,
          //   groupCells: '80%',
          //   imagesLoaded: true,
          //   pageDots: false,
          //   prevNextButtons: $thumbnails.length > 5 ? arrowsEnabled : false,
          //   asNavFor: this.template === 'image-scroll' && isScreenSizeLarge() ? '' : $productGallery[0],
          //   arrowShape: arrowShape
          // }); // Ensures Flickity is not collapsed when loaded

          // setTimeout(function () {
          //   $thumbnailProductGallery.flickity('resize');
          // }, 500);
          // $(window).on('load', function () {
          //   $thumbnailProductGallery.flickity('resize');
          // });
        }
      } else {
        //Otherwise create standard thumbnail slider
        var thumbnailGallery = new Swiper('.product-gallery__thumbnails.swiper-container', {
          // Optional parameters
          loop: false,
          slidesPerView: 4,
          slidesPerGroup: 1,
          centeredSlides: false,
          grabCursor: true,
          spaceBetween: 6,
          navigation: {
            nextEl: '.swiper-button.next',
            prevEl: '.swiper-button.previous',
          }
        });
        // $thumbnailProductGallery.flickity({
        //   cellAlign: 'center',
        //   contain: true,
        //   groupCells: '80%',
        //   imagesLoaded: true,
        //   pageDots: false,
        //   prevNextButtons: $thumbnails.length > 5 ? arrowsEnabled : false,
        //   asNavFor: this.template === 'image-scroll' && isScreenSizeLarge() ? '' : $productGallery[0],
        //   arrowShape: arrowShape
        // });
      }
      $('.product-gallery__thumbnails').find('[data-index="0"]').addClass('swiper-selected');
    }
  },
  enableProductSwatches: function enableProductSwatches() {
    $('body').on('change', '.swatch :radio', function () {
      var optionIndex = $(this).closest('.swatch').attr('data-option-index');
      var optionValue = $(this).val();
      var parentForm = $(this).closest('.product_form form');

      if (parentForm.siblings('.notify_form').length) {
        var notifyForm = parentForm.siblings('.notify_form');
      } else {
        var notifyForm = $('.js-notify-form');
      }

      var option1 = parentForm.find('.swatch_options input:checked').eq(0).val();
      var option2 = parentForm.find('.swatch_options input:checked').eq(1).val() || '';
      var option3 = parentForm.find('.swatch_options input:checked').eq(2).val() || '';

      if (option1 && option2 && option3) {
        var notifyMessage = option1 + ' / ' + option2 + ' / ' + option3;
      } else if (option1 && option2) {
        var notifyMessage = option1 + ' / ' + option2;
      } else {
        var notifyMessage = option1;
      }

      notifyForm.find(".notify_form_message").attr("value", notifyForm.find(".notify_form_message").data('body') + " - " + notifyMessage);
      $(this).closest('form').find('.single-option-selector').eq(optionIndex).val(optionValue).trigger('change');
    }); //Swatches linked with selected options

    if ($('.js-product_section').length) {
      var $productForms = $('.js-product_section').find('.product_form');
      $productForms.addClass('is-visible'); //Loop through each product and set the initial option value state

      $productForms.each(function () {
        var JSONData = $(this).data('product');
        var productID = $(this).data('product-id');
        var productSection = '.product-' + productID + ' .js-product_section';
        var swatchOptions = $(this).find('.swatch_options .swatch');

        if (swatchOptions.length > 1) {
          Shopify.linkOptionSelectors(JSONData, productSection);
        }
      });
    } //Add click event when there is more than one product on the page (eg. Collection in Detail)


    if ($('.js-product_section').length > 1) {
      $('body').on('click', '.swatch-element', function () {
        var swatchValue = $(this).data('value').toString();
        $(this).siblings('input[value="' + swatchValue.replace(/\"/g, '\\"') + '"]').prop("checked", true).trigger("change");
        var JSONData = $(this).parents('.product_form').data('product');
        var productID = $(this).parents('.product_form').data('product-id');
        var productSection = '.product-' + productID + ' .js-product_section';
        var swatchOptions = $(this).parents('.product_form').find('.swatch_options .swatch');

        if (swatchOptions.length > 1) {
          Shopify.linkOptionSelectors(JSONData, productSection);
        }
      });
    }

    this.findSelectedVariantImage();
  },
  findSelectedVariantImage: function findSelectedVariantImage() {
    $('[data-variant-selector]').on('selectedVariantChanged', function () {
      if ($(this).attr('disabled')) {
        return;
      } else {
        getIndex($(this), $(this).val());
      }
    });

    function getIndex($selector, variantID) {
      var $parentForm = $selector.parents('.product_form');
      var $option = $parentForm.find("select option[value=".concat(variantID, "]"));
      var imageID = $option.attr('data-image-id');

      if (!imageID) {
        // If there is no image, no scrolling occurs
        return false;
      }

      var index = $("[data-image-id=".concat(imageID, "]")).data('index');

      if (Shopify.theme.jsProduct.template === 'image-scroll') {
        Shopify.theme.jsProduct.scrollSelectedImage(index);
      }
    }
  },
  scrollSelectedImage: function scrollSelectedImage(variant) {
    var headerHeight = 0;
    var announceHeight = 0; // Get header height is sticky enabled

    if (Shopify.theme.jsHeader.enable_sticky == true && Shopify.theme_settings.header_layout != 'vertical') {
      headerHeight = Shopify.theme.jsHeader.getHeaderHeight();
    } // Get announcement height is sticky enabled


    if (typeof Shopify.theme.jsAnnouncementBar !== 'undefined' && Shopify.theme.jsAnnouncementBar.enable_sticky == true && Shopify.theme_settings.header_layout != 'vertical') {
      announceHeight = Shopify.theme.jsAnnouncementBar.getAnnouncementHeight();
    } // Add values


    var totalHeight = headerHeight + announceHeight;
    Shopify.theme.scrollToTop($("[data-index=\"".concat(variant, "\"]")), totalHeight);
  },
  relatedProducts: function relatedProducts() {
    $('.block__recommended-products .js-related-products-slider .products-slider').each(function (index, value) {
      var $relatedSlider = $(this);
      var slideData = {
        products_per_slide: $relatedSlider.data('products-per-slide'),
        products_available: $relatedSlider.data('products-available'),
        products_limit: $relatedSlider.data('products-limit'),
        initialIndex: 0,
        cellAlign: "left",
        wrapAround: true
      };

      if (slideData.products_available > slideData.products_per_slide && slideData.products_limit > slideData.products_per_slide) {
        slideData.wrapAround = true;
      } else {
        slideData.wrapAround = false;
      }

      if (slideData.products_available < slideData.products_per_slide || slideData.products_limit < slideData.products_per_slide) {
        $relatedSlider.addClass('container is-justify-center');
        $relatedSlider.find('.gallery-cell').addClass('column');
      } else {
        $relatedSlider.flickity({
          lazyLoad: 2,
          freeScroll: true,
          imagesLoaded: true,
          draggable: true,
          cellAlign: 'center',
          wrapAround: slideData.wrapAround,
          pageDots: false,
          contain: true,
          prevNextButtons: slideData.products_limit > slideData.products_per_slide ? true : false,
          initialIndex: slideData.initialIndex,
          arrowShape: arrowShape
        });
        setTimeout(function () {
          $relatedSlider.flickity('resize');
        }, 500);
        $(window).on('load', function () {
          $relatedSlider.flickity('resize');
        });
      }
    });
  },
  unload: function unload($section) {
    // $('.selector-wrapper select', $section).unwrap();
    // this.disableSlideshow($section);
    // $('[data-variant-selector]').off();
  }
};